var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelFlickrSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 7,
  viewBox: "0 0 14 7",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3.138 0a3.138 3.138 0 1 1 0 6.276 3.138 3.138 0 0 1 0-6.276m7.724 0a3.138 3.138 0 1 1 0 6.276 3.138 3.138 0 0 1 0-6.276m0 .966a2.172 2.172 0 1 0 0 4.344 2.172 2.172 0 0 0 0-4.344"
})));
export default SvgChannelFlickrSm;